import styled from 'styled-components';

interface ContainerProps {
  selected?: boolean;
  isChecked?: boolean;
  disabled?: boolean;
}

interface SelectedProps {
  disabled?: boolean;
}

export const Container = styled.div<ContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  border-radius: 100%;
  border: 1px solid
    ${({ disabled, selected, theme, isChecked }) =>
      !disabled && (selected || isChecked) ? theme.radioButton.active : theme.radioButton.disable};
`;

export const Selected = styled.div<SelectedProps>`
  height: 12px;
  width: 12px;
  border-radius: 100%;
  background-color: ${({ disabled, theme }) => (disabled ? theme.radioButton.disable : theme.radioButton.active)};
`;
